import api from "../apiConfig";
const paramsFactory = (p) => {
  const params = new URLSearchParams();
  if (p) {
    Object.keys(p).forEach((key) => {
      if (p[key] !== null && p[key] !== undefined && p[key] !== "") {
        params.append(key, p[key]);
      }
    });
  }
  return params;
};
// eslint-disable-next-line import/no-anonymous-default-export
export default {
  getAll(params) {
    const p = paramsFactory(params);
    return api.get(`/api/v1/user?${p}`);
  },
  getById(id) {
    return api.get(`/api/v1/user/${id}`);
  },
  update(id, data) {
    return api.post(`/api/v1/user/${id}`, data, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });
  },
  updateSalary(data) {
    return api.put(`/api/v1/user-salary/${data.id}`, data);
  },
  create(data) {
    return api.post(`/api/v1/user`, data, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });
  },
  delete(id) {
    return api.delete(`/api/v1/user/${id}`);
  },
  changePassword(data) {
    return api.put(`/api/v1/change-user-password/${data.id}`, data);
  },
  changePasswordProfile(data) {
    return api.put(`/api/v1/user-password`, data);
  },
  makeItRemotely(data) {
    return api.post(`/api/v1/user-remotely`, data);
  },
  toggleActiveDeactive(data) {
    return api.post(`/api/v1/toggle-active`, data);
  },
  userRelease(data) {
    return api.post(`/api/v1/user-release`, data);
  },
  userRejoin(data) {
    return api.post(`/api/v1/user-rejoin`, data);
  },
  promote(data) {
    return api.post(`/api/v1/user-job-title`, data);
  },
  userlog(id) {
    return api.get(`/api/v1/user-job-title/${id}`);
  },
  shiftByOneHour(data) {
    return api.post("/api/v1/change-shift-multi", data);
  },
  exportToExcel(data) {
    let params = "";
    if (data) {
      Object.keys(data).forEach((key) => {
        params += `${key}=${data[key]}&`;
      });
    }
    return api.get(`/api/v1/user-export?${params}`, {
      responseType: "blob",
    });
  },
  overTime(data) {
    return api.post(`/api/v1/user-over-time`, data);
  },

  //remotely endpoints
  getRemotelyDaysById(user_id) {
    return api.get(`/api/v1/remotely-days?user_id=${user_id}`);
  },
  getDailyRemoteLocations(data) {
    return api.post(`/api/v1/reports/users-geo`, data);
  },
  addRemotelyDays(data) {
    return api.put(`/api/v1/remotely-days`, data);
  },
  changeRemotelyDays(data) {
    return api.post(`/api/v1/user-remotely`, data);
  },
  getOverTimeData(user_id) {
    return api.get(`/api/v1/user-over-time?user_id=${user_id}`);
  },
  getActivityLog(params) {
    const p = paramsFactory(params);
    return api.get(`/api/v1/activity-log?${p}`);
  },
  getFingerPrintId() {
    return api.get(`/api/v1/new-fingerprint-id`);
  },
  sendEmail(id) {
    return api.get(`/api/v1/user/send-email/${id}`);
  },
};
